import { HttpClient } from '@store/base';
import _ from 'lodash';
import querystring from 'query-string';
import {
  GetGoodsShopDisplayStoresRequest,
  GetGoodsShopDisplayStoresResponse,
  GetGoodsShopDisplayStoreOptionsRequest,
  GetGoodsShopDisplayStoreOptionsResponse,
} from '../../model';

export class GetGoodsShopDisplayStoresGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsShopDisplayStoresRequest) {
    const query = querystring.stringify(_.omit(req, 'gdsNo'));
    const qs = query ? `?${query}` : '';

    return await this.httpClient.request<GetGoodsShopDisplayStoresResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/shop-display-stores${qs}`,
    });
  }
}

export class GetGoodsShopDisplayStoreOptionsGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetGoodsShopDisplayStoreOptionsRequest) {
    return await this.httpClient.request<GetGoodsShopDisplayStoreOptionsResponse>(
      {
        method: 'GET',
        url: `${process.env.NEXT_PUBLIC_BASE_API_HOST}/hanssem/goods-service/api/v1/goods/${req.gdsNo}/shop-display-stores/options`,
      },
    );
  }
}
